import { Clock01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";

interface PendingReportViewProps {
  message?: string;
}

export const PendingReportView = ({ message }: PendingReportViewProps) => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex max-w-md flex-col items-center justify-center gap-6 p-6">
        <div className="rounded-full bg-alpha-20 size-16 flex items-center justify-center">
          <HugeiconsIcon
            icon={Clock01Icon}
            size={24}
            className="text-content-1000"
          />
        </div>
        <p className="text-center text-sm font-medium text-content-300">
          {/* Yevhenii gost write this */}
          {message ||
            "This report will be available after the applicant completes the application"}
        </p>
      </div>
    </div>
  );
};
